import naral8_1 from "./narahoek8-00-1200x800-1.webp";

const naral8 = [naral8_1];

export default naral8;
